import React, { useState, useEffect } from "react";
import styled from "styled-components";
import PracticeGame from "../../components/PracticeGameSATS";
import Keyboard from "../../components/Keyboard";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { Scale } from 'react-scaling';
import axios from "axios";
import { navigate } from "@reach/router";//this is for the back button
import { ContactSupportOutlined } from "@material-ui/icons";

import { Button } from "../../../../globals/components/button";

import Papa from "papaparse";
const allowedExtensions = ["csv"];

//import useAuth from "../../../auth/hooks/useAuth";

var questions = [];
var currQuestion;


//used for smart allocation - refeed
var refeedQuestions = [];
var repeating = false;
var lastWord = "";
var questionCounter = 0;

//Liam - used to make timer be called and cancelled, wordTime is var for finding question time
var wordTime = 0;
let addWordTimeout;

let ratingMode = false;



export default function Game({ ...props }) {
    // const { state: authState } = useAuth();
    const [loading, setLoading] = useState(true);
    const [correctQuestions, setCorrectQuestions] = useState([]);
    const [incorrectQuestions, setIncorrectQuestions] = useState([]);
    const [score, setScore] = useState(0);
    const [combo, setCombo] = useState(0);
    const [maxCombo, setMaxCombo] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [feedback, setFeedback] = useState([]);
    const [nofeedback, setNoFeedback] = useState([]);
    const [status, setStatus] = useState("LOADING");
    const [setup, setSetup] = useState(false);
    const [custom, setCustom] = useState(false);

    const [currentLevel, setCurrentLevel] = useState(0);//0-5
    const [questionNum, setQuestionNum] = useState(0);
    const [levelScreen, setLevelScreen] = useState(false);
    const [endgame, setEndgame] = useState(false);
    const [roundCorrect, setRoundCorrect] = useState(0);

    const [remainingQuestions, setRemainingQuestions] = useState(
        props.timer ? props.timer : 10
    );

    console.log("tst: hi: " + custom);

    var timer = -1;

    var questionMax = 10;


    //console.log(props);
    if (setup === false) {
        if (props.customlist === undefined) {
            ratingMode = !!props.ratingMode;

            console.log("DEBUG: Starting Papa.parse for spelling_rating.csv");
            console.log("DEBUG: Year received as:", props.topics);

            Papa.parse("/questions/spelling_rating.csv", {
                download: true,
                header: true,
                skipEmptyLines: true,
                complete: function (results) {
                    const groupedByYear = {};

                    // 1. Determine target years (handling arrays or single strings/numbers)
                    const targetYears = Array.isArray(props.topics) 
                        ? props.topics.map(y => y.toString().trim()) 
                        : (props.topics ? [props.topics.toString().trim()] : []);
                    
                    console.log("DEBUG: Parsed targetYears for filtering:", targetYears);

                    let filteredCount = 0;
                    results.data.forEach((row, index) => {
                        const rowYear = row['Category']?.toString().trim();

                        // 2. FILTER: Only keep questions where Category matches the requested Year(s)
                        if (targetYears.length > 0 && !targetYears.includes(rowYear)) {
                            return;
                        }

                        filteredCount++;
                        if (filteredCount <= 3) {
                            console.log(`DEBUG: Row ${index} PASSED filter. Category: ${rowYear}, Word: ${row['Word']}`);
                        }

                        // 3. GROUP: Use 'Category' as the level identifier
                        if (!groupedByYear[rowYear]) groupedByYear[rowYear] = [];

                        groupedByYear[rowYear].push({
                            "question_key": row['Question Key'],
                            "sentence": row['Example sentence'],
                            "word": row['Word'],
                            "topic_key": row['Topic Key'],
                            "difficulty": rowYear 
                        });
                    });

                    console.log("DEBUG: Total rows passing filter:", filteredCount);
                    const sortedYearKeys = Object.keys(groupedByYear).sort((a, b) => Number(a) - Number(b));
                    console.log("DEBUG: Final Year Groups found:", sortedYearKeys);

                    if (sortedYearKeys.length > 0) {
                        questions = sortedYearKeys.map(key => {
                            return groupedByYear[key].sort(() => Math.random() - 0.5);
                        });

                        console.log("DEBUG: Questions array initialized. Length:", questions.length);
                        setCurrentLevel(0);
                        setQuestionNum(0);
                        setStatus("OK");
                    } else {
                        console.error("DEBUG ERROR: No questions matched targetYears:", targetYears);
                        setStatus("ERROR");
                    }
                }
            });

            setCustom(false);
            setSetup(true);
        } else if (setup == false && props.customlist != undefined) {
            questions = [];
            var list = props.customlist;
            list.forEach(q => {
                var reg = new RegExp("\\b" + q.word + "\\b", 'i');
                let questionText = q.question.replace(reg, "$");//do replacement thing
                let qobj = { "question_key": q.id, "sentence": questionText, "word": q.word, "topic_key": q.id, "topic_id": q.id }
                questions.push(qobj);
            });
            //console.log("CUSTOM LIST EXISTS")
            // console.log(questions)
            setStatus("OK");
            setCustom(true);
            setSetup(true);
        }
    }

    const { sayWord } = useSpeech();
    const [currentQuestion, setCurrentQuestion] = useState([]);
    const [wordToSay, setWordToSay] = useState("");
    const [extraChars, setExtraChars] = useState([]);


    function newQuestion() {
        clearTimeout(addWordTimeout); //Liam - clear time for previous question if not already exceeded time
        var current = currentQuestion.word;
        var newQuestion = "";
        var getNewQuestion = true;

        // Check if we have levels and if the current level exists
        if (!questions || questions.length === 0 || !questions[currentLevel]) {
            return;
        }

        //Debugging
        /*
        console.log("tst: lastQ: " + lastQuestion);
        console.log("tst: currQ: " + currentQuestion.word);
        

        console.log("tst: Counter: " + questionCounter);
        */
        console.log(questions.length, repeating);
        console.log("All questions");
        console.log(questions);
        console.log("level:" + currentLevel + "|qnum: " + questionNum);
        currQuestion = questions[currentLevel][questionNum];
        console.log(currQuestion);
        setCurrentQuestion(currQuestion);
        getNewQuestion = false;

        if (currQuestion.word != undefined) {
            getLettersFromWord(currQuestion.word);
        }
        //if only 1 question available
        if (questions[currentLevel].length == 1) {
            currQuestion = questions[0][0];
            setCurrentQuestion(currQuestion);
            if (custom) {
                ChangeWord(currQuestion.word);
            } else {
                sayWordNew(currQuestion.word);
            }
        }
        addWordTimeout = setTimeout(addCurrWord, wordTime);
        setQuestionNum(questionNum + 1);
    }

    //Liam - Get the length of the current word then times it by 2
    //times the total by 1000 to get timer in milliseconds - refeed
    function getLettersFromWord(currWord) {
        wordTime = (currWord.length * 2) * 1000;
    }

    //when time expires, add time to wrong answers list - refeed
    function addCurrWord() {
        var question = currQuestion;
        // console.log("tst: currQ: " + question);
        refeedQuestions.push(question);
        //console.log("tst: Pushed");
    }

    //When clicking back or leaving the game result reset the array so it doesn't set the question to one from a previous game. -refeed
    function Reset() {
        refeedQuestions = [];
        questionCounter = 0;
        lastWord = "";
        console.log("RESET");
    }

    function GoUpALevel() {
        setQuestionNum(0);
        setLevelScreen(true);
        let newlevel = currentLevel + 1;
        setCurrentLevel(newlevel);
        console.log("Current level: " + currentLevel);
        console.log("questions length: " + questions.length);
        if (newlevel >= questions.length || roundCorrect < 8) {
            console.log("ENDGAME");
            setEndgame(true);
        }
        setRoundCorrect(0);
    }

    function HideLevelScreen() {
        setQuestionNum(1);
        setLevelScreen(false);
        newQuestion();
    }


    function getExtraChars(word, level) {
        let alphabet = [
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "s",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
            "z"
        ];

        //remove the characters of the current answer from the alphabet
        let remainingChars = alphabet.filter(function (el) {
            return !word.includes(el);
        });

        // worh out the number of extra characters to add
        // Level x character in current word
        const extraChars = [];

        if (level > 1) {
            const wordLength = word.length;
            const extraCharCount = wordLength * (props.level - 1);
            for (var i = 0; i < extraCharCount; i++) {
                if (remainingChars.length > 0) {
                    let char =
                        remainingChars[Math.floor(Math.random() * remainingChars.length)];
                    extraChars.push(char);
                    remainingChars = remainingChars.filter(function (x) {
                        return char.indexOf(x) < 0;
                    });
                }
            }
        }
        if (level == 99) {
            return alphabet;
        }
        return extraChars;
    }

    async function checkResult(value, callback) {

        //set the current question to the last question -refeed
        questionCounter = questionCounter + 1;
        lastWord = currentQuestion.word;
        if (isSubmitting) return;
        setIsSubmitting(true);

        var addToArray = false;

        let isCorrect = true;
        if (value) {
            if (currentQuestion.word.toLowerCase() === value.toLowerCase()) {
                setRoundCorrect(roundCorrect + 1);
                setCorrectQuestions([...correctQuestions, currentQuestion]);
                isCorrect = true;
                let multiplier = combo > 0 ? combo + 1 : 1;
                multiplier = multiplier > 5 ? 5 : multiplier;
                setScore(score + multiplier * 10);
                setCombo(combo + 1);

                //check if refeed question is current
                //else is used to make it work, don't want to risk deleting in case it breaks something
                //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
                if (repeating) {
                    refeedQuestions.pop();
                    repeating = false;
                }
                else {
                    repeating = false;
                }

                if (combo > maxCombo) {
                    setMaxCombo(combo);
                }
                let result = {
                    question: currentQuestion.sentence.replace("$", " _ "),
                    correct: currentQuestion.word,
                    incorrect: value
                };
                setNoFeedback([...nofeedback, result]);
            } else {
                setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
                isCorrect = false;
                questionCounter = 0;

                if (combo === 0 && score >= 10) {
                    setScore(score - 10);
                } else {
                    setCombo(0);
                }
                let result = {
                    question: currentQuestion.sentence.replace("$", " _ "),
                    correct: currentQuestion.word,
                    incorrect: value
                };
                setFeedback([...feedback, result]);
            }

            if (callback) {
                await callback(isCorrect).then(() => {
                    GenNextQuestion();
                    setIsSubmitting(false);
                });
            } else {
                GenNextQuestion();
                setIsSubmitting(false);
            }
        }
    }

    function GenNextQuestion() {
        if (questionNum == remainingQuestions) {
            setQuestionNum(questionNum + 1);
        } else {
            newQuestion();
        }
    }



    useEffect(() => {
        if (status !== undefined && status === "OK") {
            console.log("status");
            console.log(questions);
            newQuestion();

            setLoading(false);
        }
    }, [status]);



    //when question changes play the relevant audio
    useEffect(() => {

        sayWordNew(currentQuestion.word);
        currentQuestion.word !== undefined &&
            setExtraChars(getExtraChars(currentQuestion.word.split(""), 99));
    }, [currentQuestion]);





    function ComboImage() {
        console.log(props);
        let comboNum = combo;
        if (combo > 4)
            comboNum = 4;
        var imageName = "Spelling/SpellingLevel.png" //props.gameData.animation_path + "/combo" + comboNum + ".gif";
        //return <img src= {{imageName}} style={{position:"relative"}}></img>
        console.log("../../assets/" + imageName)
        return (require("../../assets/" + imageName))
    }

    function sayWordNew(word) {
        console.log("tst: spell");
        console.log("tst: word" + word);
        if (custom == false && word != undefined && word != "") {
            console.log("tst: sound");
            word = word.toLowerCase();
            console.log("playing sound: " + word);
            var audio = new Audio("/audio/" + word + '.mp3');
            audio.play();
        }
        if (custom == true) {
            console.log("tst: change")
            ChangeWord(currentQuestion.word + " ");
        }
    }

    useEffect(() => {
        console.log("SHOULD DO TTS");
        if (wordToSay != null && wordToSay != undefined) {
            sayWord(wordToSay);
        }
    }, [wordToSay]);

    function ChangeWord(word) {
        setWordToSay(" ");
        console.log("I am changing the word");
        setWordToSay(word + " ");
    }

    function GoBack() {
        if (props.eventscreen == undefined) {
            navigate("/games/38")
        } else {
            navigate("/games")
            //navigate("/war")
        }
    }

    console.log(props);

    return (
        <>
            <PracticeGame
                eventscreen={props.eventscreen}
                parent={props}
                correct={correctQuestions}
                incorrect={incorrectQuestions}
                endgame={endgame}
                score={score}
                defaultTimer={1}
                questionLimit={remainingQuestions}
                onBack={() => {
                    GoBack()
                }}
                ratingMode={ratingMode}
                loading={loading}
                feedback={feedback}
                nofeedback={nofeedback}
                questionFontSize="0.7em"
                custom={custom}
                questionNum={questionNum}
                increaselevel={() => {
                    GoUpALevel();
                }}
                restart={() => {
                    setCombo(0);
                    setScore(0);
                    setCorrectQuestions([]);
                    setIncorrectQuestions([]);
                    clearTimeout(addWordTimeout);
                    Reset();
                }}
                homework_id={props.homework_id}
            >
                <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
                    <Scale scaleTo={1720}>
                        <Body>
                            {levelScreen == true ? (
                                <div>
                                    {endgame == true ? (
                                        <div>
                                            <h1>Looks like our journey ends here, thanks for playing!</h1>
                                            <Button>
                                                Quit
                                            </Button>
                                            <GreenButton>
                                                Feedback
                                            </GreenButton>
                                        </div>
                                    ) : (
                                        <div>
                                            <div>
                                                <h1>Congratulation on completing the round. </h1><br />
                                                <h1>press start to begin the next round.</h1>
                                                <Button
                                                    onClick={() => {
                                                        HideLevelScreen();
                                                    }}>
                                                    Start
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </div>

                            ) : (
                                <div>
                                    {currentQuestion !== undefined &&
                                        <div>
                                            <Keyboard
                                                currentQuestion={currentQuestion}
                                                onSubmitted={checkResult}
                                                playAudioButton={true}
                                                onPlayAudio={() => {
                                                    if (custom) {
                                                        ChangeWord(wordToSay);
                                                    } else {
                                                        sayWordNew(currentQuestion.word);
                                                    }
                                                }}
                                                additionalCharacters={extraChars}
                                            />
                                        </div>
                                    }
                                </div>
                            )}
                        </Body>
                    </Scale>
                </div>
            </PracticeGame>
        </>
    );
}

const Body = styled.div`
font-family: "PrimerPrint";
    width: 100%;
    height: 100%;
    background-image: url("${props => props.gameBackground}");
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 100px;
`;

const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
    margin-left: 50px;
`;


const GreenButton = styled.button`
  background: rgb(25, 160, 63);
  background: linear-gradient(
    0deg,
    rgba(25, 160, 63, 1) 0%,
    rgba(43, 196, 86, 1) 100%
  );
  width: 100%;
  border: 2px solid rgb(25, 160, 63);
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: 1em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 10px;
  }
`;
